/**
 * Luật thuần của sổ từng job — không import React, để test được và để
 * eslint không phải chọn giữa "chia sẻ hàm" với "fast refresh".
 */

import type { WorkLedgerReconcileRow } from "./workLedgerApi";

export const LEDGER_KIND_LABELS: Record<string, string> = {
  photo: "Ảnh sửa",
  extra_photo: "Ảnh mua thêm",
  print: "In ảnh",
};

export function kindLabel(kind: string): string {
  return LEDGER_KIND_LABELS[kind] ?? kind;
}

/**
 * Một dòng đối chiếu có lệch hay không.
 *
 * Hai luật quan trọng, đừng rút gọn:
 *
 *   • "Chưa ai gõ tay" (`hasTyped` false) KHÔNG tính là lệch. Trưởng phòng
 *     chưa tới kỳ chốt thì mọi số gõ tay đều bằng 0; gọi đó là lệch là báo
 *     động giả cho cả phòng, rồi người ta bỏ qua luôn cảnh báo thật.
 *
 *   • CSKH so TỪNG khoản, không so tổng. Hai khoản lệch ngược chiều nhau mà
 *     tổng vẫn bằng nhau là chuyện có thật (ghi nhầm doanh thu in sang ảnh
 *     sửa) — so tổng thì bỏ sót đúng ca đó.
 */
export function isMismatch(r: WorkLedgerReconcileRow): boolean {
  if (!r.hasTyped) return false;
  if (r.dept === "retouch") {
    return (r.ledgerPhotoCount ?? 0) !== (r.typedPhotoCount ?? 0);
  }
  return (
    (r.ledgerExtraPhotoRevenue ?? 0) !== (r.typedExtraPhotoRevenue ?? 0) ||
    (r.ledgerPrintRevenue ?? 0) !== (r.typedPrintRevenue ?? 0)
  );
}
